import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CircleCheckOutlineIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="check-circle" {...props} />;
};

export { CircleCheckOutlineIcon };
